var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Icon',{attrs:{"label":"Divided Card","allowClickOnMobile":_vm.allowClickOnMobile},scopedSlots:_vm._u([{key:"default",fn:function({ on }){return [_c('v-icon',_vm._g({staticStyle:{"color":"#000"},style:({ fontSize: _vm.size })},on),[_vm._v(_vm._s(_vm.icon))])]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }